<section>
    <div class="cover" appRatio [x]="16" [y]="9">
        <p-skeleton height="100%" width="100%" styleClass="img"></p-skeleton>
        <p-skeleton height="30px" width="100%" styleClass="description"></p-skeleton>
    </div>
</section>